<template>
  <div
    class="divHeadFirstWidge"
    v-lazy:background-image="{
      src: headBg,
      loading: headBgLazy,
    }"
  >
    <div class="divContent">
      <subject-flow-widge
        :subject="subject"
        :project="name"
        :routerLink="routerLink"
      ></subject-flow-widge>
      <div class="divFlexContent">
        <div class="divName">
          <img v-lazy="nameImg" />
        </div>
        <div class="divDesc">
          {{ desc }}
        </div>
        <pre-publish-widge
          :data="date"
          color="rgba(58,176,237,1)"
          bgColor="rgba(225,250,255,1)"
          :links="linkData"
        ></pre-publish-widge>
      </div>
    </div>
    <div class="divProject">
      <div class="divIndustry">
        <img class="divImg" :src="logo" />
        <span class="spanDesc">{{ logoDesc }}</span>
      </div>
      <div class="divNum">
        <ul>
          <li v-for="(item, index) in numItems" :key="index">
            <p class="pNum">
              {{ item.num }} <em>{{ item.unit }}</em>
            </p>
            <p class="pDesc">{{ item.type }}</p>
          </li>
        </ul>
      </div>
      <div class="divVideo" @click="handleVideo(video)" v-if="video">
        <div class="divBox"></div>
        <div class="divTriangle">
          <img src="../../common/img/video_orange.png" />
        </div>
        <div class="videoDesc">项目介绍</div>
      </div>
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
  </div>
</template>

<script>
import MenuAdd from "./../../../../components/video";
import subjectFlowWidge from "./../../../../components/subjectFlowWidge";
import prePublishWidge from './../../common/components/prePublishWidge'
export default {
  components: {
    subjectFlowWidge,
    prePublishWidge,
    MenuAdd,
  },
  props: {
    subject: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    logo: {
      type: String,
      default: "",
    },
    logoDesc: {
      type: String,
      default: "",
    },
    numItems: {
      type: Array,
      default: () => [],
    },
    video: {
      type: String,
      default: "",
    },
    nameImg: {
      type: String,
      default: "",
    },
    headBg: {
      type: String,
      default: require("./../img/headBg3.png"),
    },
    headBgLazy: {
      type: String,
      default: require("./../img/headBg3.jpg"),
    },
    linkData:{
      type:Array,
      default:()=>[]
    }
  },
  computed: {
    routerLink() {
      return {
        path: "/java",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/headFirstWidge.scss";
.divHeadFirstWidge {
  .pNum {
    color: rgba(3, 192, 254, 1) !important;
    em {
      color: rgba(3, 192, 254, 1) !important;
    }
  }
  .divVideo {
    box-shadow: 0px 4px 120px 0px rgba(9, 224, 196, 0.57) !important;
    .divBox {
      box-shadow: 0px 0px 10px 2px rgba(9, 224, 196, 0.34) !important;
    }
  }
}
</style>
